import Phaser from 'phaser';
import {gsap} from 'gsap';

import game2Config from '../../../config/game2';


export default class RecBtn{

    constructor(container){
        this.scene =  window.GAME_REF.scene;

        this.emitter = new Phaser.Events.EventEmitter();
        this.container = container;
        this.ripple = null;
        this.btn = null;
        this.timebarRot = {startAngle:0, endAngle:0};
        this.isActive = false;
        this.mode = 'rec';

        this.timer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    render(){
        this.wrap.visible = true;
        
        this.btn.alpha = 0;
        this.btn.setScale(1.1);

        this.timer = gsap.delayedCall(2.5, ()=>{
            this.timer = null;

            this.scene.tweens.add({
                targets: this.btn,
                alpha: 1,
                scaleX: 1,
                scaleY: 1,
                duration: 450,
                ease: 'Back.easeOut',
            });
        });
    }

    start(){
        this.btn.setScale(1.1);
        this.btn.setFrame(0);

        this.isActive = true;
        this.ripple.visible = true;
        this.hand.visible = true;

        this.scene.tweens.add({
            targets: this.btn,
            scaleX: 1,
            scaleY: 1,
            duration: 450,
            ease: 'Sine.easeInOut',
        });

        this.scene.tweens.add({
            targets: this.hand,
            scaleX: 1.1,
            scaleY: 1.1,
            duration: 500,
            ease: 'Sine.easeInOut',
            yoyo: true, 
            repeat: -1
        });
    }

    
    reRec(){
        this.isActive = true;
        this.ripple.visible = true;
        this.wrap.visible = true;
        this.hand.visible = true;

        this.btn.alpha = 0;
        this.btn.setScale(1.1);
        this.scene.tweens.add({
            targets: this.btn,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 450,
            ease: 'Back.easeOut',
        });
    }

    
    hide(){
        this.wrap.visible = false;
    }

    reset(){
        this.mode = 'rec';
        this.isActive = false;
        this.wrap.visible = false;
        this.btn.setFrame(0);
        this.timebarRot = {startAngle:0, endAngle:0};
        this.timebar.clear();
        this.hand.visible = false;
        this.ripple.visible = false;
    }


    playMode(){
        this.mode = 'play';
        this.timebarRot = {startAngle:0, endAngle:0};
        this.timebar.clear();

        this.btn.setFrame(1);
        this.btn.setScale(1.1);
        this.scene.tweens.add({
            targets: this.btn,
            scaleX: 1, scaleY: 1,
            duration: 500,
            ease: 'Sine.easeInOut',
            onComplete: ()=>{
                this.progress();
            }
        });
    }


    progress(){

        this.scene.tweens.add({
            targets: this.timebarRot,
            endAngle: Phaser.Math.DegToRad(360),
            duration: game2Config.time,
            ease: 'Linear',
            onStart: ()=>{
                this.isActive = false;
                this.ripple.visible = false;
            },
            onUpdate: ()=>{
                this.timebar.clear();
                this.timebar.beginPath();
                this.timebar.arc(0, 0, 117, 0, this.timebarRot.endAngle, false);
                this.timebar.strokePath();
            },
            onComplete: ()=>{
                if(this.mode === 'rec') this.emitter.emit(this.EVENT_REC_END);
                else this.emitter.emit(this.EVENT_PLAY_END);
            }
        });
    }


    _init(){
        this.EVENT_REC_START = 'rec_start';
        this.EVENT_REC_END = 'rec_end';
        this.EVENT_PLAY_END = 'play_end';

        this.wrap = this.scene.add.container(160, 620);
        this.container.add(this.wrap);

        this._createRipple();
        this._createRecBtn();
        this._createTimeBar();

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    _createRipple(){
        const scaleList = [0.5, 0.25, 0];
        const durationList = [1000, 1500, 2000];

        this.ripple = this.scene.add.container(0, 0);
        this.ripple.visible = false;
        this.wrap.add(this.ripple);

        for(let i=0; i<3; i++){
            const item = this.scene.add.image(0, 0, 'rec_ripple');
            item.setScale(scaleList[i]);
            this.ripple.add(item);

            this.scene.tweens.add({
                targets: item,
                scale: 1.2,
                alpha: 0,
                duration: durationList[i],
                ease: 'Cubic.easeOut',
                repeat: -1
            });
        }
    }
    
    _createRecBtn(){
        this.btn = this.scene.add.sprite(0, 0, 'btn_rec');
        this.btn.setFrame(2);
        this.btn.setOrigin(0.5, 0.5);
        this.wrap.add(this.btn);

        this.hand = this.scene.add.image(90, 90, 'ico_hand');
        this.hand.visible = false;
        this.wrap.add(this.hand);

        // マウス インタラクション
        const cw = this.btn.getBounds().width;
        const ch = this.btn.getBounds().height;
        this.btn.setInteractive(new Phaser.Geom.Rectangle(0, 0, cw, ch), Phaser.Geom.Rectangle.Contains);
        
        this.btn.on('pointerover', ()=>{
            if(!this.isActive) return;
            this.scene.input.setDefaultCursor('pointer');
        });
        this.btn.on('pointerout', ()=>{
            this.scene.input.setDefaultCursor('default');
        });
        this.btn.on('pointerdown', ()=>{
            if(!this.isActive) return;

            this.isActive = false;
            this.emitter.emit(this.EVENT_REC_START);
            //this.hand.visible = false;
        });
    }

    _createTimeBar(){
        this.timebar = this.scene.add.graphics({ lineStyle: { width: 18, color: 0xff0000 } });
        this.timebar.beginPath();
        this.timebar.arc(0, 0, 117, Phaser.Math.DegToRad(this.timebarRot.startAngle), Phaser.Math.DegToRad(this.timebarRot.endAngle), false);
        this.timebar.strokePath();
        this.timebar.rotation = Phaser.Math.DegToRad(-90);
        this.wrap.add(this.timebar);
    }


    _pause(){
        if(this.timer) this.timer.pause();
    }

    _resume(){
        if(this.timer) this.timer.resume();
    }
}